export function createRoutes() {
  return [
    {
      path: 'schedule-templates',
      component: () => import(/* webpackChunkName: "ScheduleTemplateChrome" */ './ScheduleTemplateChrome.vue'),
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "ScheduleTemplateList" */ './ScheduleTemplateList.vue'),
        },
        {
          path: 'create',
          name: 'createSchedule',
          components: {
            default: () => import(/* webpackChunkName: "ScheduleTemplateList" */ './ScheduleTemplateList.vue'),
            createSchedule: () => import(/* webpackChunkName: "CreateScheduleTemplateModal" */ './CreateScheduleTemplateModal.vue'),
          },
        },
        {
          path: ':scheduleTemplateId',
          component: () => import(/* webpackChunkName: "ScheduleTemplateEditChrome" */ './ScheduleTemplateEditChrome.vue'),
          children: [
            {
              path: '/',
              component: () => import(/* webpackChunkName: "ScheduleTemplateEdit" */ './ScheduleTemplateEdit.vue'),
            },
          ],
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
